import * as React from 'react';
import { Skeleton } from '@mui/material';

const ExternshipCardSkeleton = (): React.ReactElement => {
  return <Skeleton height="80px" sx={{ transform: 'none', padding: 0 }} />;
};

export default ExternshipCardSkeleton;
